export const formatPercent = (value: number) =>
  `${new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(Math.round(value))}%`;

export const getCompletionColor = (rate: number) => {
  if (rate < 50) return 'red';
  if (rate < 80) return 'orange';
  return 'green';
};

export const computeCompletionRate = (completed: number, total: number) =>
  total > 0 ? (completed / total) * 100 : 0;
